export default __webpack_public_path__ + "static/carlotta-zorzi-chapman-15d8eb14c25ba6cf0cb4a116fbb5c766.svg";